/* Caipi Redesign — Home interactions. Review-swiper arrows. */
(function () {
  'use strict';

  function bindReviews(root) {
    if (root.dataset.rdRevBound === '1') return;
    var revs = root.querySelector('[data-rd-reviews]');
    if (!revs) return;
    root.dataset.rdRevBound = '1';
    function scrollBy(dir) {
      var card = revs.querySelector('.rd-review');
      var step = card ? card.getBoundingClientRect().width + 12 : revs.clientWidth * 0.8;
      revs.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    var prev = root.querySelector('[data-rd-rev-prev]');
    var next = root.querySelector('[data-rd-rev-next]');
    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
  }

  // Pull the live shop rating out of the Judge.me footer widget and write it
  // into story stats marked [data-rd-shop-rating]. Judge.me populates async,
  // so poll briefly until the score appears.
  function fillShopRating() {
    var targets = document.querySelectorAll('[data-rd-shop-rating]');
    if (!targets.length) return true;
    var scoreEl = document.querySelector('.jdgm-all-reviews-rating__score');
    var raw = scoreEl ? parseFloat(scoreEl.textContent.trim().replace(',', '.')) : NaN;
    if (!raw || isNaN(raw)) return false;
    var de = raw.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    targets.forEach(function (t) { t.textContent = de + ' ★'; });
    return true;
  }

  function pollShopRating() {
    var tries = 0;
    (function step() {
      if (fillShopRating() || tries++ > 24) return;
      setTimeout(step, 500);
    })();
  }

  function init() {
    document.querySelectorAll('.rd-root[data-section-id]').forEach(bindReviews);
    pollShopRating();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
